export const titleProps = {
  fontSize: { xs: 24, sm: 32, md: 48, lg: 32, xl: 42 },
  fontWeight: 'bold',
  lineHeight: {
    xs: '30px',
    sm: '42px',
    md: '53px',
    lg: '42px',
    xl: '48px',
  },
};
